import { render } from "./BroadcastModal.vue?vue&type=template&id=2d8ddc4d&scoped=true"
import script from "./BroadcastModal.vue?vue&type=script&lang=js"
export * from "./BroadcastModal.vue?vue&type=script&lang=js"

import "./BroadcastModal.vue?vue&type=style&index=0&id=2d8ddc4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ddc4d"]])

export default __exports__